import {
  Container,
  Header,
  HomeContainer,
  NavContainer,
  RightNav,
  UserContainer,
} from "./styles";
import { useAuthContext } from "../../../contexts/auth-contex";
import theme from "../../../styles/theme";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import capivara from "../../../assets/images/capivara.png";

export const ClientHeader: React.FC = () => {
  const { user } = useAuthContext();

  return (
    <div style={{ display: "flex", height: "auto" }}>
      <Container>
        <Header>
          <HomeContainer>
            <img className="logoImg" src={capivara} alt="Logo Capivara" />
          </HomeContainer>
          <NavContainer>
            <RightNav>
              <UserContainer>
                <PersonOutlineOutlinedIcon
                  sx={{
                    fontSize: theme.fontSize.md2,
                  }}
                />
                <span>{user?.fullName}</span>
              </UserContainer>
            </RightNav>
          </NavContainer>
        </Header>
      </Container>
    </div>
  );
};
